﻿import Swiper from '../lib/Swiper/swiper-bundle.esm.browser.min.js'
import News from './News.js'
import Poll from './Poll.js'
import { containsHTML, getDisplayDate, getIframe, getThumbnailURL, isNullOrWhitespace } from '../../util.js'
import { createImgModal } from '../home.js'
import dayjs from '../lib/dayjs.min.js'

export class PreviewNews extends window.HTMLElement {
  constructor() {
    super()

    this.attachShadow({ mode: 'open' })
    const template = document.querySelector('#single-news-wrapper')
    this.shadowRoot.appendChild(template.content.cloneNode(true))
  }

  connectedCallback() {
    this.setVariables()
    this.setNews()
    this.setHeight()
    this.slideIn()
    this.slideOut()
  }

  setVariables() {
    this._news = new News(JSON.parse(this.dataset.data))
    this._container = this.shadowRoot.querySelector('#single-news-container')
    this._btnBack = this.shadowRoot.querySelector('#btn-back-single-news')
    this._author = this.shadowRoot.querySelector('.single-news-author')
    this._btnNewsOptions = this.shadowRoot.querySelector('.single-news-btn-options')
    this._pollTitle = this.shadowRoot.querySelector('.single-news-poll-title')
    this._title = this.shadowRoot.querySelector('.single-news-title')
    this._created = this.shadowRoot.querySelector('.single-news-created')
    this._to = this.shadowRoot.querySelector('.single-news-to-full')
    this._content = this.shadowRoot.querySelector('.single-news-content')
    this._links = this.shadowRoot.querySelector('.single-news-links')
    this._poll = this.shadowRoot.querySelector('.single-news-poll')
    this._imgWrap = this.shadowRoot.querySelector('.image-wrap')
    this._commentWrap = this.shadowRoot.querySelector('.comment-wrap')
    this._commentInputWrap = this.shadowRoot.querySelector('#comment-input-wrap')
    this._commentInput = this._commentInputWrap.querySelector('textarea')
    this._commentBtn = this._commentInputWrap.querySelector('#btn-comment')
    this._likes = this.shadowRoot.querySelector('.single-news-likes span')
    this._interactable = this._news.CanInteract
  }

  setNews() {
    this._commentWrap.remove()
    this._commentInputWrap.remove()
    this._btnNewsOptions.remove()

    if (this._news.CanInteract === 'false') {
      this.shadowRoot.querySelector('.single-news-btn-wrap')?.remove()
      this.shadowRoot.querySelector('.social-wrap')?.remove()
    }

    const notPublished = dayjs(this._news.Created).isAfter(dayjs()) // if created is in the future

    this._news.Videos = JSON.parse(this._news.Videos)
    this._news.Links = JSON.parse(this._news.Links)
    this._news.Author !== '0'
      ? (this._author.textContent = `${lang_posted_by}: ${this._news.Author}`)
      : this._author.remove()
    this._title.textContent = this._news.Title

    this._created.textContent = notPublished
      ? `${lang_publishes}: ${getDisplayDate(this._news.Created)}`
      : getDisplayDate(this._news.Created)
    this._to.textContent = this._news.Groups.filter((x) => !x.isExcluded)
      .map((x) => x.groupName)
      .join(', ')
    this._content.innerHTML = this._news.Contents

    if (containsHTML(this._news.Contents)) {
      this._content.classList.add('is-html')

      this._content.querySelectorAll('a').forEach((a) => {
        a.target = '_blank'
      })
    } else {
      this._content.classList.add('pre-wrap')
    }

    for (let i = 0; i < this._news.Links.length; i++) {
      const name = this._news.Links[i].Name
      const URL = this._news.Links[i].URL

      const a = document.createElement('a')
      a.innerHTML = `
          <a href=${URL} target='_blank'>
          <i class="fas fa-link"></i>${name}
          </a>
        `

      this._links.appendChild(a)
    }

    if (this._news.Poll !== '{}' && !isNullOrWhitespace(this._news.Poll)) {
      this._poll.appendChild(this.createPoll())
    } else {
      this._pollTitle.classList.add('hidden')
    }

    const mediaLength = this._news.Images.length + this._news.Videos.length
    this._imgWrap.style.display = 'none'

    if (mediaLength !== 0) {
      if (mediaLength === 1) {
        if (this._news.Images.length) {
          const img = document.createElement('img')
          img.src = this._news.Images[0].Src
          this._imgWrap.appendChild(img)
          this._imgWrap.style.display = 'block'
          img.addEventListener('click', () => {
            createImgModal(img)
          })
        } else if (this._news.Videos.length) {
          const vid = this._news.Videos[0]
          const thumbnailURL = getThumbnailURL(vid.Type, vid.URL)

          const img = document.createElement('img')
          img.src = thumbnailURL
          img.dataset.iframe = getIframe(vid.Type, vid.URL).innerHTML
          this._imgWrap.classList.add('is-video')

          img.addEventListener('click', () => {
            createImgModal(img)
          })

          this._imgWrap.appendChild(img)
          this._imgWrap.style.display = 'block'
        }
      } else {
        const swiperDiv = document.createElement('div')
        swiperDiv.classList = 'swiper'

        const swiperWrapper = document.createElement('div')
        swiperWrapper.classList = 'swiper-wrapper'

        const imgs = []
        let jcount = 0
        for (let j = 0; j < this._news.Images.length; j++) {
          const swiperSlide = document.createElement('div')
          swiperSlide.classList = 'swiper-slide'

          const img = document.createElement('img')
          img.src = this._news.Images[j].Src
          img.dataset.index = jcount
          imgs.push(img)

          swiperSlide.appendChild(img)
          swiperWrapper.appendChild(swiperSlide)
          jcount++
        }

        for (let j = 0; j < this._news.Videos.length; j++) {
          const swiperSlide = document.createElement('div')
          swiperSlide.classList = 'swiper-slide is-video'

          const vid = this._news.Videos[j]
          const thumbnailURL = getThumbnailURL(vid.Type, vid.URL)

          const img = document.createElement('img')
          img.src = thumbnailURL
          img.dataset.iframe = getIframe(vid.Type, vid.URL).innerHTML
          img.dataset.index = jcount
          imgs.push(img)

          swiperSlide.appendChild(img)
          swiperWrapper.appendChild(swiperSlide)
          jcount++
        }

        swiperDiv.appendChild(swiperWrapper)

        for (let j = 0; j < imgs.length; j++) {
          imgs[j].addEventListener('click', () => {
            createImgModal(imgs[j], swiperDiv)
          })
        }

        this._imgWrap.appendChild(swiperDiv)

        setTimeout(() => {
          this._imgWrap.style.display = mediaLength === 0 ? 'none' : 'block'
        }, 300)

        const sw = this.shadowRoot.querySelector('.swiper')

        // eslint-disable-next-line
        new Swiper(sw, {
          slidesPerView: 1.2,
          spaceBetween: 10
        })
      }
    }

    if (this._interactable === 'true') {
      this._likes.textContent = `${this._news.Likes} ${lang_likes_this}`
    }
  }

  setHeight() {
    this._container.style.height = this.offsetHeight + 'px'
  }

  createPoll() {
    const poll = new Poll(JSON.parse(this._news.Poll))

    const pollHasEnded = dayjs(poll.endDate).isBefore(dayjs())
    const userHasVoted = false

    if (pollHasEnded) {
      this._pollTitle.querySelector('span').textContent = lang_finished_poll
      this._pollTitle.classList.add('ended')
    } else {
      this._pollTitle.querySelector('span').textContent = lang_ongoing_poll
    }

    const wrapper = document.createElement('div')
    wrapper.classList = 'poll__wrapper'

    const question = document.createElement('p')
    question.classList = 'poll__question'
    question.textContent = poll.question

    wrapper.appendChild(question)

    const answerWrapper = document.createElement('div')
    answerWrapper.classList = 'poll__answer-wrapper'

    for (let i = 0; i < poll.answers.length; i++) {
      const wrap = document.createElement('div')
      wrap.classList = 'poll__single-answer-wrapper'

      if (!pollHasEnded && !userHasVoted) {
        const input = document.createElement('input')
        input.type = poll.multipleAnswers === 'true' ? 'checkbox' : 'radio'
        input.name = 'poll-answer'
        input.value = poll.answers[i]
        input.id = `poll-answer-${i}`

        const label = document.createElement('label')
        label.setAttribute('for', `poll-answer-${i}`)
        label.textContent = poll.answers[i]

        wrap.appendChild(input)
        wrap.appendChild(label)
      } else {
        const answer = document.createElement('div')
        answer.classList = 'poll__answer'
        answer.textContent = poll.answers[i]

        wrap.appendChild(answer)
      }

      answerWrapper.appendChild(wrap)
    }

    wrapper.appendChild(answerWrapper)

    const errorText = document.createElement('p')
    errorText.classList = 'poll__error-text hidden'
    errorText.textContent = lang_choose_option

    wrapper.appendChild(errorText)

    const thanks = document.createElement('p')
    thanks.classList = 'poll__vote-thanks hidden'
    thanks.textContent = lang_thank_you_vote
    wrapper.appendChild(thanks)

    if (userHasVoted) {
      thanks.classList.remove('hidden')
    }

    if (!pollHasEnded && !userHasVoted) {
      const voteButton = document.createElement('div')
      voteButton.classList = 'button-round blue'
      voteButton.textContent = lang_vote

      voteButton.addEventListener('click', () => {
        const answers = [...answerWrapper.querySelectorAll('input')]?.filter((x) => x.checked)?.map((x) => x.value)

        answers.length === 0 ? errorText.classList.remove('hidden') : errorText.classList.add('hidden')

        if (answers.length === 0) {
          return
        }

        voteButton.remove()
        thanks.classList.remove('hidden')
      })

      wrapper.appendChild(voteButton)
    }

    const infoText = document.createElement('p')
    infoText.classList = 'poll__info-text'
    infoText.textContent = pollHasEnded
      ? lang_poll_ended
      : `${lang_poll_ends} ${getDisplayDate(poll.endDate).toLowerCase()}`

    wrapper.appendChild(infoText)

    return wrapper
  }

  slideIn() {
    setTimeout(() => {
      this.classList.add('active')
      this._commentInputWrap.classList.add('active')
    }, 1)
  }

  slideOut() {
    this._btnBack.addEventListener('click', () => {
      document.documentElement.classList.remove('no-scroll')

      this.classList.remove('active')
      this._commentInputWrap.classList.remove('active')

      setTimeout(() => {
        this.remove()
      }, 400)
    })
  }
}

window.customElements.define('preview-news', PreviewNews)
